module.exports = __webpack_public_path__ + "img/84.1.cf98e79b.jpg";